module.exports = __webpack_public_path__ + "static/img/main3-bg-1.7cddf83.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/main3-bg-1.png
// module id = VMu8
// module chunks = 7